import { useState, useEffect, useRef } from 'react';
import { HiEyeOff, HiEye } from 'react-icons/hi';
import { ValidationCompany } from './Validation';
import { TextSignInSignUp } from '../Components/TextSignInorSignUp';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useGetSettings } from '../Hooks/useSettings';
import { toast } from 'react-toastify';
import { sortArray } from '../utils';

const InitialzedinputError = {};
function Company() {
  const { countries, getCountryId, getUserTypeId } = useGetSettings();
  const navigate = useNavigate();

  const [passwordShown, setPasswordShown] = useState(false);
  const [instruction, setInstruction] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputError, setInputError] = useState(InitialzedinputError);
  const [inputs, setInputs] = useState({
    companyName: '',
    companyEmail: '',
    countryCode: '',
    country: '',
    phoneNumber: '',
    userName: '',
    password: '',
    confirmPassword: '',
    refferrerCode: '',
    agree: false,
  });

  const formData = {
    first_name: inputs.companyName,
    user_type_id: getUserTypeId('Organization User'),
    last_name: inputs.companyName,
    organization_name: inputs.companyName,
    organization_email: inputs.companyEmail,
    email: inputs.companyEmail,
    phone: inputs.countryCode + inputs.phoneNumber,
    username: inputs.userName,
    password: inputs.password,
    ref_code: inputs.refferrerCode,
    agree: inputs.agree,
    country_id: getCountryId(inputs.country),
    firebase_id: 1,
  };

  const handleChange = (e) => {
    const target = e.target;
    const { value, name, type, checked } = target;
    setInputs((input) => ({
      ...input,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputError(ValidationCompany(inputs));

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/register`,
        formData
      );

      sessionStorage.setItem('user', JSON.stringify(response.data));
      navigate('/otppage', {
        replace: true,
        state: { otpType: 'Register' },
      });
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
    setConfirmPasswordShown(!passwordShown);
  };

  const inputReference = useRef(null);
  useEffect(() => {
    if (inputReference.current !== null) {
      inputReference.current.focus();
    }
  }, []);
  return (
    <div className='pt-20'>
      <div className='mx-auto max-w-4xl pb-16 bg-p-wh flex items-center flex-col gap-16 border-hf border-t-bk rounded-lg pt-16 px-6'>
        <div className='text-center'>
          {' '}
          <h1 className='text-2xl font-pin font-semibold text-p-pin'>
            Sign Up
          </h1>
          <TextSignInSignUp
            title='Sign In'
            question='Already have an account?'
          />
        </div>
        {/* {isSubmiting ? (
          <div className='px-6 py-2 rounded-md text-red-500 bg-red-500/25'>
            {resError}
          </div>
        ) : null} */}
        <form
          className='flex items-center flex-col gap-4 w-full box-border'
          onSubmit={handleSubmit}
        >
          <div className='flex flex-col md:flex-row gap-6 w-full'>
            <div className='flex flex-col gap-6 w-full'>
              <div className='flex flex-col gap-2 w-full'>
                <label className='text-p-bk text-base font-pin'>
                  Company name<sup className='text-red-500'>*</sup>
                </label>
                <input
                  type='text'
                  className=' focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4 focus:outline-none focus:ring focus:b-mc'
                  name='companyName'
                  value={inputs.companyName}
                  onChange={handleChange}
                  ref={inputs.companyName ? null : inputReference}
                />
                <small className='text-red-500'>{inputError.companyName}</small>
              </div>
              <div className='flex flex-col gap-2 w-full'>
                <label className='text-p-bk text-base font-pin'>
                  Company email<sup className='text-red-500'>*</sup>
                </label>
                <input
                  type='email'
                  className=' focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4 focus:outline-none focus:ring focus:b-mc'
                  name='companyEmail'
                  value={inputs.companyEmail}
                  onChange={handleChange}
                />
                <small className='text-red-500'>
                  {inputError.companyEmail}
                </small>
              </div>

              <div className='flex flex-col gap-2 w-full'>
                <label className='text-p-bk text-base font-pin'>
                  Country<sup className='text-red-500'>*</sup>
                </label>

                <select
                  name='country'
                  className='py-2 focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk pr-4'
                  value={inputs.country}
                  onChange={handleChange}
                >
                  <option className='py-8'></option>
                  {countries.sort(sortArray).map((country) => (
                    <option key={country.id} className='py-8'>
                      {country.name}{' '}
                    </option>
                  ))}
                </select>
                <small className='text-red-500'>{inputError.country}</small>
              </div>
              <div className='flex flex-col gap-2 w-full'>
                <label className='text-p-bk text-base font-pin'>
                  Phone number<sup className='text-red-500'>*</sup>
                </label>
                <div className='flex flex-row gap-6'>
                  <select
                    name='countryCode'
                    className='py-2 focus:outline-none focus:ring focus:b-mc border-2 w-1/3 h-11 rounded-lg border-t-bk pr-4'
                    value={inputs.countryCode}
                    onChange={handleChange}
                  >
                    <option className='py-8'></option>
                    {countries.sort(sortArray).map((country) => (
                      <option key={country.id} className='py-8'>
                        {country.code}{' '}
                      </option>
                    ))}
                  </select>
                  <input
                    type='number'
                    className='[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none focus:ring focus:b-mc border-2 w-2/3 h-11 rounded-lg border-t-bk px-4'
                    name='phoneNumber'
                    value={inputs.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
                <small className='text-red-500'>{inputError.phoneNumber}</small>
              </div>
              <div className='w-full'>
                <div className='flex  items-start gap-3 w-full'>
                  <input
                    type='checkbox'
                    className=' border-2 h-11 rounded-lg border-t-bk w-5'
                    name='agree'
                    checked={inputs.agree}
                    onChange={handleChange}
                  />
                  <label className='text-p-bk text-sm md:text-base font-pin pt-2.5'>
                    By checking the box you agree to the{' '}
                    <br className='hidden md:block' />
                    <span className='text-b-mc'>Terms</span> and{' '}
                    <span className='text-b-mc'>Conditions</span> of the
                    platform
                  </label>
                </div>
                <small className='text-red-500'>{inputError.agree}</small>
              </div>
            </div>
            <div className='flex flex-col gap-6 w-full'>
              <div className='flex flex-col gap-2 w-full'>
                <label className='text-p-bk text-base font-pin'>
                  Username<sup className='text-red-500'>*</sup>
                </label>
                <input
                  type='text'
                  className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
                  name='userName'
                  value={inputs.userName}
                  onChange={handleChange}
                />
                <small className='text-red-500'>{inputError.userName}</small>
              </div>
              <div className='flex flex-col gap-2 w-full'>
                <div className='flex flex-col gap-2 w-full relative'>
                  <label className='text-p-bk text-base font-pin'>
                    Password<sup className='text-red-500'>*</sup>
                  </label>
                  <input
                    type={passwordShown ? 'text' : 'password'}
                    className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
                    name='password'
                    value={inputs.password}
                    onChange={handleChange}
                    onFocus={() => {
                      setInstruction(!instruction);
                    }}
                    onBlur={() => {
                      if (instruction) {
                        setInstruction(!instruction);
                      }
                    }}
                  />
                  {passwordShown ? (
                    <HiEye
                      className='absolute bottom-3 right-4'
                      onClick={togglePassword}
                    />
                  ) : (
                    <HiEyeOff
                      className='absolute bottom-3 right-4 text-s-bk'
                      onClick={togglePassword}
                    />
                  )}
                </div>
                {instruction ? (
                  <small className='bg-b-mct p-2 '>
                    Minimum eight characters, at least one letter, one number
                    and one special character
                  </small>
                ) : null}
                <small className='text-red-500'>{inputError.password}</small>
              </div>

              <div className='flex flex-col gap-2 w-full'>
                <div className='flex flex-col gap-2 w-full relative'>
                  <label className='text-p-bk text-base font-pin'>
                    Confirm password<sup className='text-red-500'>*</sup>
                  </label>
                  <input
                    type={confirmPasswordShown ? 'text' : 'password'}
                    className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
                    name='confirmPassword'
                    value={inputs.confirmPassword}
                    onChange={handleChange}
                    onFocus={() => {
                      setInstruction(!instruction);
                    }}
                    onBlur={() => {
                      if (instruction) {
                        setInstruction(!instruction);
                      }
                    }}
                  />
                  {passwordShown ? (
                    <HiEye
                      className='absolute bottom-3 right-4'
                      onClick={togglePassword}
                    />
                  ) : (
                    <HiEyeOff
                      className='absolute bottom-3 right-4 text-s-bk'
                      onClick={togglePassword}
                    />
                  )}
                </div>

                <small className='text-red-500'>
                  {inputError.confirmPassword}
                </small>
              </div>

              <div className='flex flex-col gap-2 w-full'>
                <label className='text-p-bk text-base font-pin'>
                  Refferrer Code <span className='text-xs'>(Optional)</span>
                </label>
                <input
                  type='text'
                  className='[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
                  name='refferrerCode'
                  value={inputs.refferrerCode}
                  onChange={handleChange}
                />
              </div>
              <button
                type='submit'
                className='text-p-wh px-4 h-12 hover:bg-blue-300 focus:bg-blue-400 py-2.5 w-full mt-3 font-semibold bg-b-mc rounded-lg'
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'Sign up'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default Company;
